import { createSelector } from 'reselect';
import { TemplatesState } from '../templates/types';
import { GalleryState } from './types';

export const getGallery = (state: any): TemplatesState => state.gallery;
export const isGalleryLoading = (state: any): TemplatesState['loadingData'] => state.gallery.loadingData;

export const gallerySelector = (state): GalleryState['templates'] => state.gallery.templates;
export const selectedGalleryIdSelector = (state): GalleryState['selectedTemplateId'] =>
    state.gallery.selectedTemplateId;

export const selectedGallerySelector = createSelector(
    gallerySelector,
    selectedGalleryIdSelector,
    (templates, selectedTemplateId) => {
        return templates.find((template) => template.id === selectedTemplateId);
    },
);
